import React from 'react';
import { PACKAGE_FEATURES } from '@src/constants/package';
import CheckOrCross from '../../Shared/CheckOrCross';

const globalPremiumVoiceFeatures = ({ packages }) =>
  packages.map((pkg) => (
    <CheckOrCross
      key={pkg?.code}
      isCheck={pkg?.features?.includes(PACKAGE_FEATURES.PREMIUM_GLOBAL_VOICE)}
    />
  ));

export default globalPremiumVoiceFeatures;
